import { render } from "./PromptForm.vue?vue&type=template&id=27eba5d0&scoped=true&ts=true"
import script from "./PromptForm.vue?vue&type=script&lang=ts"
export * from "./PromptForm.vue?vue&type=script&lang=ts"

import "./PromptForm.vue?vue&type=style&index=0&id=27eba5d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27eba5d0"]])

export default __exports__